// src/components/Login.js
import React, { useState } from "react";
import { db, auth } from "../firebase";
// 补充导入 setDoc（之前漏了）
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

export default function Login({ setIsLoggedIn, setUsername }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 邮箱密码登录
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      return alert("请输入邮箱和密码 / Please enter email and password");
    }
    if (loading) return;

    setLoading(true);
    try {
      // 1. 登录 Firebase 账号
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. 获取用户信息
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        alert("用户信息不存在 / User info not found");
        setLoading(false);
        return;
      }
      const userData = userDoc.data();

      // 3. 更新最后登录时间
      await updateDoc(doc(db, "users", user.uid), {
        lastLoginTime: new Date()
      });

      // 4. 登录成功，更新状态
      localStorage.setItem("quizUsername", userData.nickname);
      setUsername(userData.nickname);
      setIsLoggedIn(true);
      navigate("/"); // 跳转到应用主页
    } catch (err) {
      console.error("登录失败:", err);
      let errorMsg = "登录失败 / Login failed: ";
      if (err.code === "auth/user-not-found") {
        errorMsg += "用户不存在 / User not found";
      } else if (err.code === "auth/wrong-password") {
        errorMsg += "密码错误 / Wrong password";
      } else {
        errorMsg += err.message;
      }
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Google 快捷登录（自动注册/登录）
  const handleGoogleLogin = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const userCredential = await signInWithPopup(auth, provider);
      const user = userCredential.user;

      // 检查用户是否已注册，未注册则自动创建
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        // 自动注册（生成唯一昵称）
        let nickname = user.displayName || `Google_${user.uid.slice(0, 6)}`;
        await setDoc(doc(db, "users", user.uid), {
          uid: user.uid,
          email: user.email,
          nickname: nickname,
          country: "Unknown",
          authType: "google",
          registerTime: new Date(),
          lastLoginTime: new Date()
        });
      } else {
        // 更新最后登录时间
        await updateDoc(doc(db, "users", user.uid), {
          lastLoginTime: new Date()
        });
      }

      // 登录成功
      const userData = (await getDoc(doc(db, "users", user.uid))).data();
      localStorage.setItem("quizUsername", userData.nickname);
      setUsername(userData.nickname);
      setIsLoggedIn(true);
      navigate("/");
    } catch (err) {
      console.error("Google 登录失败:", err);
      alert("Google login failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 游客模式（跳过注册/登录）
  // src/components/Login.js
const handleGuestMode = () => {
  try {
    // 🔴 1. Clear ALL progress data for guests
    localStorage.removeItem("quizProgress"); // Replace with your progress key
    localStorage.removeItem("completedQuestions"); // Add all progress keys
    localStorage.removeItem("quizScore");

    // 🔴 2. Set guest username (mark as guest)
    localStorage.setItem("quizUsername", "guest");
    setUsername("guest");
    setIsLoggedIn(true);
    navigate("/");
  } catch (error) {
    console.error("Guest mode error:", error);
  }
};
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-pink-50 via-rose-50 to-rose-100 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6">
        <h1 className="text-2xl font-semibold mb-6" style={{ color: "#C86B85" }}>
          🍷 Login / 登录账号
        </h1>

        {/* 邮箱密码登录表单 */}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            placeholder="Email / 邮箱"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password / 密码"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          <button
            type="submit"
            className={`w-full py-2 rounded-lg text-white font-semibold ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            style={{ background: "linear-gradient(90deg,#F7C6D4,#F4D19B)" }}
            disabled={loading}
          >
            {loading ? "Processing..." : "Login / 登录"}
          </button>
        </form>

        {/* 其他登录方式 */}
        <div className="flex gap-3 my-4">
          <button
            onClick={handleGoogleLogin}
            className={`flex-1 py-2 rounded-lg text-white font-semibold ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            style={{ background: "linear-gradient(90deg,#4285F4,#34A853)" }}
            disabled={loading}
          >
            Google 登录
          </button>
          <button
            onClick={handleGuestMode}
            className="flex-1 py-2 rounded-lg border"
            disabled={loading}
          >
            游客模式
          </button>
        </div>
        <div className="mt-2 text-center">
          <Link to="/forgot-password" className="text-pink-600 hover:underline text-sm">
            Forgot Password? / 忘记密码？
          </Link>
        </div>
        {/* 没有账号？跳转到注册页 */}
        <div className="mt-2 text-center text-gray-600">
          <span>没有账号？ / No account? </span>
          <Link to="/register" className="text-pink-600 hover:underline">
            Register / 注册
          </Link>
        </div>
      </div>
    </div>
  );
}